import { FetchPlus } from './FetchPlus';

export const api = new FetchPlus();

